const TOKEN_KEY = 'HSM-TOKEN';
const USER_INFO_KEY = 'HSM-USER-INFO';

export interface UserInfoStorage {
  username?: string;
  realName?: string;
  avatar?: string;
  roleName?: string;
}

export const getToken = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.localStorage.getItem(TOKEN_KEY) || '';
};

export const setToken = (token: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(TOKEN_KEY, token);
};

export const getUserInfo = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const userInfo = window.localStorage.getItem(USER_INFO_KEY);

  if (!userInfo) {
    return undefined;
  }

  try {
    return JSON.parse(userInfo) as UserInfoStorage;
  } catch {
    window.localStorage.removeItem(USER_INFO_KEY);
    return undefined;
  }
};

export const setUserInfo = (userInfo: UserInfoStorage) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
};

export const removeToken = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(TOKEN_KEY);
};

export const removeUserInfo = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(USER_INFO_KEY);
};

export const clearAuth = () => {
  removeToken();
  removeUserInfo();
};

export const hasToken = () => Boolean(getToken());
